import { Component, inject, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DecimalPipe, JsonPipe, KeyValuePipe, NgClass, NgStyle } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Subject } from 'rxjs';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

import { EntitySelectionDirective } from '../../../directives/entity-selection.directive';
import { FullTextSearchPipe } from '../../../utilities/pipes/full-text-search.pipe';
import { AuthenticationService } from '../../../utilities/services/authentication.service';
import { Entity, Intent, Message } from '../../../models/training.model';
import { EllipsisTextDirective } from '../../../directives/ellipsis-text.directive';


@Component({
    selector: 'chat-interaction',
    imports: [FormsModule, NgClass, NgbPopover, NgStyle, EntitySelectionDirective, KeyValuePipe, JsonPipe, DecimalPipe, FullTextSearchPipe, EllipsisTextDirective],
    templateUrl: './chat-interaction.component.html',
    styleUrls: ['./chat-interaction.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ChatInteractionComponent implements OnInit, OnDestroy {
  @Input() viewFilters = {
    parameters: true,
    page: true,
    flow: true,
    contextOut: true,
    response: true,
    sentiment: true,
    status: true,
  };
  forbiddenTraining = false;
  @Input() uneditableView? = false;

  private _interaction!: Message;
  get interaction() {
    return this._interaction;
  }
  @Input() set interaction(interaction) {
    this._interaction = interaction;
    if (this._interaction) {
      setTimeout(() => this.onUpdateEntities.next(this.interaction.editedDfEntityJson));
    }
  }
  @Input() intents!: Array<Intent>;

  @ViewChild('popIntent') popIntent!: NgbPopover;
  @ViewChild('popEntity') popEntity!: NgbPopover;

  private readonly authenticationService = inject(AuthenticationService);

  entityPopOffset!: string;
  onUpdateEntities: Subject<any> = new Subject<any>();

  subscriptions: any = {};
  entities: Array<Entity> = [];
  intentFilter!: string;
  entityFilter!: string;

  get showParameter() {
    return (
      Object.keys(this.interaction.editedDfEntityJson || {}).length > 0
    );
  }

  showEvent(interaction: Message) {
    return interaction.dfEventName;
  }
  showUserSays(interaction: Message) {
    return (interaction.userQuery !== null && !interaction.dfEventName) || interaction.fallback;
  }

  trainableIntent(interaction: Message) {
    return (
      interaction.userQuery !== null &&
      !this.uneditableView &&
      interaction.isTrained == null
    );
  }

  showIntent(interaction: Message) {
    return interaction.dfIntentName || interaction.fallback || interaction.userQuery !== null; // TO Verify
  }

  ngOnInit() {
    if (!this.authenticationService.isAuthorized('training.write')) {
      this.forbiddenTraining = true;
    }
  }

  ngOnDestroy() {
    Object.keys(this.subscriptions).forEach((key: string) => {
      this.subscriptions[key].unsubscribe();
    });
  }

  getSplittedMessages(outputMessage: string): Array<string> {
    return outputMessage?.split('##');
  }

  orderBlank() {
    return 0;
  }

  isLastParameter(parametersObject: any, index: number): boolean {
    return Object.keys(parametersObject).length === index + 1;
  }

  togglePopEntity($event: any) {
    if (this.interaction.isTrained != null) return;

    this.entityPopOffset = `${$event.offset}px`;

    if (this.popEntity.isOpen()) {
      this.popEntity.close();
    } else {
      this.entities = this.intents.find(intent => intent.name === this.interaction.editedDfIntentName)?.parameters || [];
      this.popEntity.open({ $event });
    }
  }

  togglePopIntent() {
    if (this.popIntent.isOpen()) {
      this.popIntent.close();
    } else {
      this.popIntent.open();
    }
  }

  setIntent(intent: Intent) {
    this.interaction.editedDfIntentName = intent.name;
    this.popIntent.close();
    this.interaction.editedDfEntityJson = null;
    this.onUpdateEntities.next(this.interaction.editedDfEntityJson);
  }

  setEntity(entityKey: string, entityEvent: any) {
    if (entityEvent.oldKey) delete this.interaction.editedDfEntityJson[entityEvent.oldKey];
    if (!this.interaction.editedDfEntityJson) this.interaction.editedDfEntityJson = {};

    this.interaction.editedDfEntityJson[entityKey] = entityEvent.value;
    this.onUpdateEntities.next(this.interaction.editedDfEntityJson);
    this.popEntity.close();
  }

  removeParameter(interaction: any, parameterKey: any) {
    delete interaction.editedDfEntityJson[parameterKey];
    this.onUpdateEntities.next(interaction.editedDfEntityJson);
  }

  updateUserQuery(target: EventTarget | null) {
    const textContent = (target as HTMLInputElement).textContent;
    this.interaction.editedUserQuery = textContent;
  }
}
